import React, { useEffect, useState } from 'react';
import DataTable from 'react-data-table-component';
import { http } from '../helper';
import { BaseUrl } from '../common/config';
import DatePicker from "react-datepicker";
import { format } from 'date-fns';
export const SectorwiseTopsellingproducts = ({ }) => {

    
    var currentTime = new Date();
    var currentyear = currentTime.getFullYear();
    var currentMonth = currentTime.getUTCMonth() + 1;
    const [groupedProducts,setGroupedProducts]=useState([]);
    const [sectorOptions, setSectorOptions] = useState([]);
    const [sector, setSector] = useState("Education - Secondary Schools");
    const [productGroup, setProductGroup] = useState('All');
    const [productGroupOptions,setProductGroupOptions] = useState([]);
    const [filter, setFilter] = useState(0);
    const [catFilter, setCatFilter] = useState('All');
    const [filtertext, setFilterText] = useState('');
    const [topSellingProducts, setTopSellingProducts] = useState([]);
    const [isLoading, setIsLoading] = useState(true);
    const [sectorLoading,setSectorLoading] =useState(true);
    const [showDatePicker, setShowDatePicker] = useState(false);
    const [fromDate, setFromDate] = useState(null);
    const [toDate, setToDate] = useState(null);
    const getCurrentFiscalYear = () => {
        const today = new Date();
        const year = today.getFullYear();
        const month = today.getMonth() + 1;
        // Fiscal year starts in September
        const startYear = month >= 9 ? year : year - 1;
        const endYear = startYear + 1;
        return `${startYear}-${endYear}`;
    };
    const [period, setPeriod] = useState(getCurrentFiscalYear());
    const [months, setMonths]=useState('9');
    const [quarter,setQuarter]=useState('');
    const MonthNames = ["Sep", "Oct", "Nov", "Dec", "Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug"];
    const currentFiscalMonth = new Date().getMonth(); // 0-indexed: Jan = 0, Apr = 3, Sep = 8
            
    const quarterNames = {
        1: "Sep - Nov",
        2: "Dec - Feb",
        3: "Mar - May",
        4: "Jun - Aug"
        };
    //Find Product CategoryName by CtegoryID    
    const getProductCategory = (productCategoryId) =>{
        const id = String(productCategoryId);
        if(id == "1") return 'pizza';
        if(["10","13"].includes(id)) return 'pasta-rice-noodle-sauces';
        if(["11","12"].includes(id)) return 'burrito'; 
        if(id == "14") return 'desserts';
        return '';
    }

    const getGroupedData = (filteredData) => {
        let sectorProducts = {
            sector,
            products: [],
            orderIds: [],
            ordercount: 0,
        };

        filteredData.forEach((product) => {
            const {year,month,quarter: prodQuarter} = product._id;
            // Monthly filter
            if (filter === 'monthly' && parseInt(months) !== month) return;
            // Quarterly filter
            if (filter === 'quarterly'&& parseInt(quarter) !== parseInt(prodQuarter)) return;

            const productIndex = sectorProducts.products.findIndex(
                pdt => pdt.productNumber === product._id.productNumber
            );

            if (productIndex !== -1) {
                sectorProducts.products[productIndex].totalQuantitySold += product.totalQuantitySold;
            } else {
                sectorProducts.products.push({
                    productNumber: product._id.productNumber,
                    productDescription: product._id.productDescription,
                    totalQuantitySold: product.totalQuantitySold,
                    productCategoryId: product._id.productCategoryId,
                    productGroup: product._id.productGroup,
                    productCategoryName: getProductCategory(product._id.productCategoryId),
                });
            }

            if (product.orderId && !sectorProducts.orderIds.includes(product.orderId)) {
                sectorProducts.orderIds.push(product.orderId);
            }
        });

        sectorProducts.totalOrders = sectorProducts.orderIds.length;
        sectorProducts.products.sort((a, b) => b.totalQuantitySold - a.totalQuantitySold);
        setGroupedProducts([sectorProducts]); // keep wrapped in array
    };

        const getCurrentFiscalQuarter = () => {
        const month = new Date().getMonth() + 1; // 1–12
        if (month >= 9 && month <= 11) return 1;   // Sep–Nov
        if (month === 12 || month <= 2) return 2;  // Dec–Feb
        if (month >= 3 && month <= 5) return 3;    // Mar–May
        return 4;                                  // Jun–Aug
    };


    const getAvailableQuarters = (selectedFiscalYear) => {
        const currentFiscalYear = getCurrentFiscalYear();
        const currentQuarter = getCurrentFiscalQuarter();
        return Object.entries(quarterNames)
            .filter(([quarterNumber]) => (
                selectedFiscalYear !== currentFiscalYear || Number(quarterNumber) <= currentQuarter
            ))
            .map(([quarterNumber, label]) => (
                <option key={quarterNumber} value={quarterNumber}>
                    {label}
                </option>
            ));
    };

    useEffect(() => {
        const now = new Date();
        const fiscalQuarterMap = {
            9: 1, 10: 1, 11: 1,
            12: 2, 1: 2, 2: 2,
            3: 3, 4: 3, 5: 3,
            6: 4, 7: 4, 8: 4
        };
        setQuarter(fiscalQuarterMap[now.getMonth() + 1]);
    }, []);

    useEffect(() => {
        const fetchSectors = async () => {
            try {
                const response = await http.get(BaseUrl + "admin/account");
                const accountsData = response.data.data;
                const uniqueSectors = [...new Set(accountsData.map((acc) => acc.Sectors).filter(Boolean))];
                const defaultSector = "Education - Secondary Schools";
                setSectorOptions([defaultSector, ...uniqueSectors.filter(s => s !== defaultSector)]);
                // sector state is set to the default if it's valid
                if (!uniqueSectors.includes(sector)) {
                    setSector(defaultSector);
                }
                setSectorLoading(false);
            } catch (error) {
                console.error("Error fetching sectors:", error);
            }
        };

        const fetchProductGroups = async() =>{
            try {
                const response = await http.get(BaseUrl + "admin/product/masterentries/productgroup");
                const groupData = response.data.data;
                const uniqueGroups = [...new Set(groupData.map(acc => acc.MasterValue).filter(Boolean))].sort((a, b) => a.toLowerCase().localeCompare(b.toLowerCase()));
                setProductGroupOptions(["All", ...uniqueGroups.filter(g => g !== "All")]);
            } catch (error) {
                console.error("Error fetching sectors:", error);
            }
        }

        fetchSectors();
        fetchProductGroups();
    }, []);

    useEffect(() => {
        setIsLoading(true);
        if (filter === "custom" && (!fromDate || !toDate)) {
            setIsLoading(false); 
            // Don't make the API call if dates are missing for the "custom" filter
            return;
        }

        let URL1 = BaseUrl + "admin/sectorwiseTopsellingProducts";
        let payload = {};
        if (filter === 'custom') {
            payload = {
                filter: filter, 
                sector: sector,
                datefrom: format(new Date(fromDate), "yyyy-MM-dd"),
                dateto: format(new Date(toDate), "yyyy-MM-dd")
            }
            setShowDatePicker(false);
        }
         else if (filter === 'weekly') {
           payload = {
                    filter: filter,
                    sector: sector,
                    datefrom: "",
                    dateto: "",
                    // period: period
                }; 
            setShowDatePicker(false);
        }
        else if ([ "monthly", "quarterly","FYdata"].includes(filter)) 
            {
                payload = {
                    filter: filter,
                     sector: sector,
                    datefrom: "",
                    dateto: "",
                    period: period
                }; 
            }
        else {
            payload = {
                filter: parseInt(filter),
                 sector: sector,
                  datefrom: '',
                dateto: '',
            }
        }

        http.post(URL1, payload).then((response) => {
            setIsLoading(false);
            getGroupedData(response.data.data || []);
        }).catch((err) => {
            setIsLoading(false); 
            console.log(err);
        })
    }, [filter, fromDate, toDate, months, quarter, period, sector]);
   
   useEffect(() => {
        let tableData = groupedProducts.find(g => g.sector === sector)?.products || [];
        if (catFilter !== 'All') tableData = tableData.filter(d => d.productCategoryName === catFilter);
        if (productGroup !== 'All') tableData = tableData.filter(d => d.productGroup?.trim().toLowerCase().replace(/s$/, '') ===productGroup?.trim().toLowerCase().replace(/s$/, ''));
        tableData = tableData.filter(items=>items.totalQuantitySold > 0);
        setTopSellingProducts(tableData);
    }, [groupedProducts, sector, catFilter, productGroup]);

    // Calculate dynamic pagination options
    const calculatePaginationOptions = (totalRecords, interval) => {
        const options = [];
        for (let i = interval; i <= totalRecords; i += interval) {
            options.push(i);
        }
        return options;
    };

    const DateChange = (value, type) => {
        if (type === "from") {
            setFromDate(value);

            if (toDate && value && value > toDate) {
                setToDate(null);
            }
        } else if (type === "to") {
            if (!fromDate || value >= fromDate) {
                setToDate(value);
            } else {
                // Handle invalid date selection
                //alert("The 'To' date cannot be earlier than the 'From' date.");
                setToDate(null);
            }
        }
    };

    const totalRecords = topSellingProducts?.length; // Get the total records count
    const paginationOptions = calculatePaginationOptions(totalRecords, 10); // Generate options with interval of 10

    const changeCatFilterHandler = (e) => {
        setCatFilter(e.target.value);
        setShowDatePicker(false);
    }

    const changeProductGroupHandler = (e) => {
        setProductGroup(e.target.value);
    }

   const changePeriodHandler = (e) => {
  const newPeriod = e.target.value;
  setPeriod(newPeriod); // update selected fiscal year in state
  //split fiscal year
  const [newStartYear, newEndYear] = newPeriod.split('-').map(Number);
 
  const fiscalStartMonthIndex = 8; // 0-based index for September
 
  const today = new Date();
  const currentFiscalYear = getCurrentFiscalYear();
  //compare sleted year with currentfiscalyear
  const isCurrentFiscalYear = newPeriod === currentFiscalYear;
 
  // MONTHLY filter logic
  if (filter === 'monthly') {
    let visibleMonthNames = MonthNames;
 
    if (isCurrentFiscalYear) {
      // Calculate current fiscal month index
      const currentMonthIndex = today.getMonth(); // 0-based
      const monthsPassedSinceFiscalStart =
        (currentMonthIndex - fiscalStartMonthIndex + 12) % 12;
      const maxVisibleIndex = monthsPassedSinceFiscalStart;
 
      visibleMonthNames = MonthNames.slice(0, maxVisibleIndex + 1);
    }
 
    const selectedMonthIndex = MonthNames.indexOf(months);
    const isValidMonth =
      selectedMonthIndex >= 0 && selectedMonthIndex < visibleMonthNames.length;
 
    if (!isValidMonth) {
      const defaultMonthNumber = ((0 + fiscalStartMonthIndex) % 12) + 1;
      setMonths(String(defaultMonthNumber));
    }
  }
 
  // QUARTERLY filter logic
  if (filter === 'quaterly') {
    const currentQuarter = getCurrentFiscalQuarter();
    let maxQuarter = 4;
 
    if (isCurrentFiscalYear) {
      maxQuarter = currentQuarter;
    }
 
if (parseInt(quarter) > maxQuarter) {
  setQuarter(maxQuarter > 0 ? String(maxQuarter) : "1");
}
 
  }
};
    const changeMonthHandler = (e) => {
        setMonths(e.target.value);
    };
    const changeFilterHandler = (e) => {
        setFilter(e.target.value);
        setFilterText(e.target.options[e.target.selectedIndex].text);
        if (e.target.value === 'custom') {
            setShowDatePicker(true);

        } else {
            setShowDatePicker(false);
            setFromDate(null);
            setToDate(null);
            setFilter(e.target.value);

        }
    };
    const options = [];

    for (let i = currentyear; i >= 2023; i--) {
        if (i === currentyear && currentMonth < 9) {
            continue;
          }
        const year = i;
        options.push(
            <option value={year + "-" + (year + 1)}>{year + "-" + (year + 1)}</option>
        );
    }

    function fixDescription(description) {
    const textarea = document.createElement('textarea');
    textarea.innerHTML = description;
    let decoded = textarea.value;
    decoded = decoded.replace(/&apos;/g, "'")
                     .replace(/apos;/g, "'")
                     .replace(/&quot;/g, '"')
                     .replace(/quot;/g, '"')
                     .replace(/&amp;/g, '&')
                     .replace(/amp;/g, '&');

    return decoded;
    }

    const currentFiscalYear = getCurrentFiscalYear();
    let visibleMonthNames = MonthNames;
    if (period === currentFiscalYear) {
    // Limit to current fiscal month
    const fiscalIndex = (new Date().getMonth() - 8 + 12) % 12; // Sep=0, Oct=1, ... Aug=11
    visibleMonthNames = MonthNames.slice(0, fiscalIndex + 1);
    }

    let loadingbuffer = isLoading ? 'loading-buffer' : '';
    const columns = [
        {
            name: "Product Code",
            selector: row => {
                if (row.productNumber && typeof row.productNumber === "string") {
                    return row.productNumber.includes("_")
                        ? row.productNumber.substring(0, row.productNumber.indexOf("_"))
                        : row.productNumber;
                }
                return ""; // Return a default value if ProductNumber is undefined or not a string
            },
            sortable: false,
        },
        {
            name: "Product Name",
            selector: row => (
                <>
                    {fixDescription(row.productDescription)}        
                    <a
                        className= "title-tooltip title-top"
                        data-title={row.productCategoryId === "1"
                            ? "PIZZA"
                            : row.productCategoryId === "10" || row.productCategoryId === "13"
                                ? "PASTA, RICE & NOODLE SAUCES"
                            : row.productCategoryId === "14"
                            ? "DESSERTS"
                                : "BURRITO"}>
                        <i className="fa fa-th-list" aria-hidden="true"></i>
                    </a>
                </>
            ),
            sortable: false,
        },
        {
            name: "Product Group",
            selector: row =>(<>
            { row.productGroup.replaceAll("amp;", "&")
                        .replaceAll("apos;'", "'' ")
                        .replaceAll("quot;'", "'' ")}</>
            ),
            sortable: false,
        },
        {
          name: "Quantity Sold",
          selector:  row => row.totalQuantitySold,
          sortable: false,
        },
    ];
    const customStyles = {
        rows: {
            style: {
                minHeight: '25px',
            },
        },
        headCells: {
            style: {
                padding: '8px', // override the cell padding for head cells
            },
        },
        cells: {
            style: {
                padding: '8px', // override the cell padding for data cells
            },
        },
        headCellStyle: {
        justifyContent: 'center',
    }
};
    const paginationComponentOptions = {
        rowsPerPageText: "",
        rangeSeparatorText: "",
        selectAllRowsItem: true,
        selectAllRowsItemText: "",
        noRowsPerPage: "",
    };
    return (
        <div className={`chart-container chart-top-selling sectorTop-selling sector ${loadingbuffer}`}>
            <div className="chart-Hdr">
                <h2 style={{ textAlign: "left" }}>Sector-Based Top Selling Products</h2>
                <div className="chart-fltr-Hldr">
                    <div className="chart-fltr">
                        {
                        <select value={sector} onChange={(e) => setSector(e.target.value)}>
                            {sectorOptions.map((sector, index) => (
                                <option key={index} value={sector}>{sector}</option>
                            ))}
                        </select>
                        }
                    </div>
                    <div className="chart-fltr">
                        {
                        <select
                            value={catFilter}
                            onChange={(e) => changeCatFilterHandler(e)}
                        ><option value={"All"}>All</option>
                            <option value={"pizza"}>PIZZA</option>
                            <option value={"pasta-rice-noodle-sauces"}>PASTA, RICE & NOODLE SAUCES</option>
                            <option value={"burrito"}>BURRITO</option>
                            <option value={"desserts"}>DESSERTS</option>
                        </select>
                        }
                    </div>
                     <div className="chart-fltr">
                        {
                            <select
                                value={productGroup}
                                onChange={(e)=> changeProductGroupHandler(e)}
                        >
                         {productGroupOptions &&
                            productGroupOptions.map((option,index)=>(
                                <option key={index} value={option}>{option}</option>
                            ))
                         }
                        </select>
                        }
                        </div>
                   
                      <div className="chart-fltr" onMouseEnter={() => {
                                if (filter === "custom" && !showDatePicker) {
                                    setShowDatePicker(true);
                                }
                                }}
                                onMouseLeave={() => {
                                    if (filter === "custom" && showDatePicker) {
                                        setShowDatePicker(false);

                                    }
                                }}>
                     {<select
                        value={filter}
                        onChange={(e) => changeFilterHandler(e)}
                    ><option value={0}>All</option>
                        <option value={1}>Past 1 Day</option>
                        <option value={"weekly"}>Current Week</option>
                        <option value={"monthly"}>Monthly</option>
                        <option value={"quarterly"}>Quarterly</option>
                        <option value={"FYdata"}>FY Data</option>
                        <option value={30}>Past 30 Days</option>
                        <option value={90}>Past 90 Days</option>
                        <option value={180}>Past 180 Days</option>
                        <option value={365}>Past 1 Year</option>
                        <option value={'custom'}>Custom Date</option>
                    </select>} 
                    {showDatePicker && (
                        <div className="date-picker-container">
                            <label>From:</label>
                            <DatePicker
                                selected={fromDate}
                                onChange={(date) => DateChange(date, "from")}
                                showDisabledMonthNavigation
                                dateFormat="dd/MM/yyyy"
                                disablePast={true}
                                maxDate={new Date()}
                                placeholderText="Select Date"
                            />
                            <label>To:</label>
                            <DatePicker
                                selected={toDate}
                                showDisabledMonthNavigation
                                dateFormat="dd/MM/yyyy"
                                onChange={(date) => DateChange(date, "to")}
                                disablePast={true}
                                maxDate={new Date()}
                                placeholderText="Select Date"
                            />
                        </div>
                    )}
               
                    {filter === 'monthly' && 
                        <select value={months} onChange={(e)=>changeMonthHandler(e)}>
                            {visibleMonthNames.map((monthName, index) => {
                                    const monthNumber = ((index + 8) % 12) + 1; // fiscal-to-calendar month number
                                    return (
                                        <option key={monthNumber} value={monthNumber}>
                                        {monthName}
                                        </option>
                                    );
                            })}
                        </select>
                    }
                    {filter === 'quarterly' && (
                        <select
                            value={quarter}
                            onChange={(e) => setQuarter(Number(e.target.value))}
                        >
                            {getAvailableQuarters(period)}
                        </select>
                          
                    )}
                    {(filter === 'monthly' || filter === 'quarterly' || filter==='FYdata') &&
                        <select
                        
                        value={period}
                        onChange={(e) => changePeriodHandler(e)}
                        >
                        {options}
                        </select>
                          }
                    </div> 
                 </div>
                    <div className="fltr-sub-val">
                    {topSellingProducts.length > 0 && (<span className='fltr-val'>
                        {"Total Qty Sold"}: <strong>
                        { 
                        topSellingProducts.reduce((acc, item) => item.totalQuantitySold > 0 ? acc + item.totalQuantitySold : acc, 0)
                            
                        }
                        </strong></span>
                    )}
                      </div>
              
            </div>
            <DataTable
                columns={columns}
                data={topSellingProducts}
                customStyles={customStyles}
                noDataComponent={<div className='no-records-found'>Sorry, no data found for your filtered search.</div>}
                pagination
                paginationPerPage={10}
                paginationRowsPerPageOptions={[10, 20, 40, 60, 80, 100]}
                paginationComponentOptions={paginationComponentOptions}
            />
        </div>
    );
};